import { FC } from 'react'
import s from './Booking.module.sass'
import { Template } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/Template'
import { TemplateCardProps } from '@widgets/Restaurant/RestCards/RestCard/type/TemplateCardProps'
import TypeAndPrice from '@widgets/Restaurant/RestCards/RestCard/ui/Components/TypeAndPrice/TypeAndPrice'
import { useCurrentSize } from '@shared/lib/helpers/classes'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { PromoBadgeLabel } from '@shared/ui/Feedback/PromoBadges/PromoBadgeLabel'
import { QuickBookingRestCard } from '@widgets/Restaurant/QuickBooking/variants/QuickBookingRestCard'
import { EGG } from '@shared/api/analytics'

const Booking: FC<TemplateCardProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = (
  props,
) => {
  const [size] = useCurrentSize(props.sizes)

  const price = props.data.price

  const handleClickSlot = () => {
    EGG.entity.booking.slots_quick_booking_slot_click(props.data, { section_index: props.analytic?.section_index || 0 })
  }

  const handleClickDots = () => {
    EGG.entity.booking.slots_quick_booking_dots_click(props.data, { section_index: props.analytic?.section_index || 0 })
  }

  return (
    <BlockBoundary>
      <Template {...props}>
        {!!props.data.discounts.remarked && (
          <PromoBadgeLabel label={'Скидка'} className={s['promo-label']}>
            -{props.data.discounts.remarked}₽
          </PromoBadgeLabel>
        )}

        {!!props.data.discounts.restoplace && (
          <PromoBadgeLabel label={'Скидка'} className={s['promo-label']}>
            -{props.data.discounts.restoplace}₽
          </PromoBadgeLabel>
        )}

        <TypeAndPrice
          restType={props.data.type}
          priceRange={size !== 'S' ? price.level : null}
          priceLink={price.tag.url}
        />

        <QuickBookingRestCard restData={props.data} onClickDots={handleClickDots} onClickSlot={handleClickSlot} />
      </Template>
    </BlockBoundary>
  )
}

export default Booking
